import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var ShowCategories = function(param) {
    var minorCategories = param.minorCategories, majorCategory = param.majorCategory;
    return /*#__PURE__*/ _jsx("div", {
        className: "show-categories",
        "aria-hidden": true,
        children: minorCategories && minorCategories.length > 0 ? "".concat(majorCategory, " | ").concat(minorCategories.join(" ● ")) : "".concat(majorCategory)
    });
};
export default ShowCategories;
